export enum UserRoles {
  Admin = 'admin'
}
